import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'cleanHtml'
})
export class CleanHtmlPipe implements PipeTransform {
    transform(value) {
        if (!value) { return ''; }

        return  value ? String(value).replace(/<[^>]+>/gm, ' ') : '';
    }
}




// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/pipes/clean-html.pipe.ts